import styled from "styled-components";
import { StatusFilterButton } from "../atoms/StatusFilterButton";

const Wrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export function StatusFilterGroup({
  value = [],
  onChange,
}) {
  const toggleStatus = (status) => {
    if (value.includes(status)) {
      onChange(
        value.filter((s) => s !== status)
      );
    } else {
      onChange([...value, status]);
    }
  };

  return (
    <Wrapper>
      <StatusFilterButton
        label="未受付"
        status="ready"
        checked={value.includes("ready")}
        onClick={() => toggleStatus("ready")}
      />

      <StatusFilterButton
        label="受付済み"
        status="checked"
        checked={value.includes("checked")}
        onClick={() => toggleStatus("checked")}
      />

      <StatusFilterButton
        label="遅れ"
        status="late"
        checked={value.includes("late")}
        onClick={() => toggleStatus("late")}
      />
    </Wrapper>
  );
}